/**
 * Farce TransitionHook
 */

import * as playerActions from '../redux/actions/player';
import * as UIActions from '../redux/actions/ui';
import { getRouteLocation } from '../utils/router';

import { Actions as FarceActions } from 'farce';
import { TransitionHook } from 'found';
import * as nextTick from 'next-tick';
import { Store } from 'redux';

import { CartPagePath } from '../components/pages/Cart';
import { CheckoutPagePath } from '../components/pages/Checkout';

type TransitionHookCreator = (store: Store<IStoreState>) => TransitionHook;

export const transitionHookCreator: TransitionHookCreator = ({ dispatch, getState }) =>
  (location) => {
    const state = getState();
    const { found, player, ui } = state;
    const goingBackOrForward = 'delta' in location;

    // If pathname didn't change, we don't do anything
    if (location.pathname === found.match.location.pathname) {
      return true;
    }

    switch (location.pathname) {
      case CartPagePath:
        // If going to Cart, we make sure to remove the current playing track term list
        if (player.currentTrack && ui.player && ui.player.termListIsVisible) {
          dispatch(UIActions.togglePlayerTermListVisibility(false));
        }
        break;
      case CheckoutPagePath:
        // If going to Checkout, we make sure to kill the player because it becomes a distraction
        if (player.currentTrack) {
          if (player.isTrackPlaying) {
            dispatch(playerActions.pause());
          }
          dispatch(playerActions.clearQueue());

          if (ui.player && ui.player.termListIsVisible) {
            dispatch(UIActions.togglePlayerTermListVisibility(false));
          }
        }
        break;
      default:
        break;
    }

    // We apply the persistent query string middleware to keep the query string when navigating
    if (goingBackOrForward) {
      // If user is navigation back or forward, we want to keep the current query string
      nextTick(() => {
        dispatch(FarceActions.replace(getRouteLocation(location.pathname, found.match.location.query)));
      });
    }

    // If Track Details Component is open in current page, we close it to avoid
    // design issues with pages where Track Details is not available
    if (ui.trackDetails && ui.trackDetails.visible) {
      dispatch(UIActions.toggleTrackDetailsVisibility(false));
    }

    return true;
  };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/router/transitionHook.ts